// Shared by the client app and the client-contact-change function: how a typed email or mobile number is cleaned up
// before a code is sent to it. Kept free of imports so Deno can load it.
const EMAIL_PATTERN = /^[^@\s]+@[^@\s.]+(\.[^@\s.]+)+$/;
const E164_PATTERN = /^\+[1-9]\d{7,14}$/;

export function normalizeEmail(value) {
    const text = String(value ?? '').trim().toLowerCase();
    return text.length <= 254 && EMAIL_PATTERN.test(text) ? text : null;
}

// US-style numbers without a country code get +1; anything else must start with + and a country code.
export function normalizeMobile(value) {
    const text = String(value ?? '').trim();
    if (!text) return null;
    const digits = text.replace(/\D/g, '');
    let candidate;
    if (text.startsWith('+')) candidate = `+${digits}`;
    else if (digits.length === 10) candidate = `+1${digits}`;
    else if (digits.length === 11 && digits.startsWith('1')) candidate = `+${digits}`;
    else return null;
    return E164_PATTERN.test(candidate) ? candidate : null;
}

// US numbers compare by their ten digits: "4045550142", "(404) 555-0142", "14045550142" and "+14045550142" are one number.
// Numbers from other countries compare by all their digits.
export function phoneDigits(value) {
    const digits = String(value ?? '').replace(/\D/g, '');
    return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
}

// Is what the client typed the same as what is on file? Email: trimmed, any case. Phone: see phoneDigits. Nothing on file and
// nothing typed counts as the same.
export function sameContactValue(kind, typed, saved) {
    if (kind === 'email') return String(typed ?? '').trim().toLowerCase() === String(saved ?? '').trim().toLowerCase();
    return phoneDigits(typed) === phoneDigits(saved);
}

// "+1 (404) 555-0123" for a US number however it is stored on file (BL-177 Step 2d: the same layout as src/lib/phone.js);
// other countries are shown as stored. Kept import-free for the client app and Deno, so non-US numbers are not regrouped here.
export function formatMobile(value) {
    const text = String(value ?? '').trim();
    if (/^\+(?!1\d{10}$)/.test(text)) return text;
    const digits = phoneDigits(text);
    const match = /^(\d{3})(\d{3})(\d{4})$/.exec(digits);
    return match ? `+1 (${match[1]}) ${match[2]}-${match[3]}` : text;
}
